module.exports = __webpack_public_path__ + "static/media/preview.fe961f49.webp";